module.exports = __webpack_public_path__ + "img/imgvallec.db524f78.png";